import PropTypes from 'prop-types';
import React from "react";

const SVG = ({
  style = {},
  fill = "#444",
  width = "100%",
  height = "100%",
  className = "",
  viewBox = "0 0 41 32"
}) =>(
    <svg
      width={width}
      style={style}
      height={height}
      viewBox={viewBox}
      preserveAspectRatio="xMidYMid slice"
      x="0"
      y="0"
      xmlns="http://www.w3.org/2000/svg"
      className={`svg-icon ${className || ""}`}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        fill={fill}
        d="M20.605 12.701l-4.316-5.979L20.605 0l4.33 6.722zm6.79-2.213l-3.849 5.306 6.351 9.814H11.34l6.351-9.718-3.849-5.402L-.014 32h41.237z" /> 
    </svg>
);

SVG.propTypes = {
  direction: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string
};

export default SVG;
